module.exports = __webpack_public_path__ + "img/AK0092-DG.ee2d1f17.jpg";